import React from "react";
import { Layout } from "antd";

const CustomLayout = ({ className, children }) => <Layout className={className}>{children}</Layout>;
export default CustomLayout;
